import gql from 'graphql-tag'

export const SEAT_VIEWER_QUERY = gql`
query {
  seatViewer {
    data {
      attributes {
        Intro {
          Title
          Description
          Caption
        }
        DesktopImage {
          data {
            attributes {
              url
              alternativeText
              formats
            }
          }
        }
        TabletImage {
          data {
            attributes {
              url
              alternativeText
              formats
            }
          }
        }
        MobileImage {
          data {
            attributes {
              url
              alternativeText
              formats
            }
          }
        }
        HelpingFans {
          title
          description
          smallerText
          buttonText
          buttonUrl
          buttonIsExternal
        }
        flexContent {
          ... on ComponentContentContentIntro {
            introTitle: Title  
            Description 
          }
          ... on ComponentContentQuote {
            name
            title
            organisation
            image {
              data {
                attributes {
                  url
                  alternativeText
                  formats
                }
              }
            }
          }
          ... on ComponentContentVideo {
            image {
              data {
                attributes {
                  url
                  alternativeText
                  formats
                }
              }
            }
            videoLink
          }
          ... on ComponentContentLargeFact {
            caption
            fact
          }
          ... on ComponentContentGridImages {
            images {
              data {
                attributes {
                  url
                  alternativeText
                  formats
                }
              }
            }
          }
          ... on ComponentContentTwoColumns {
            twoColumnsTitle: Title
            Content
          }
          ... on ComponentContentWebsiteCta {
            ctaTitle: Title
            Link
            buttonLabel
          }
          ... on ComponentContentQuoteSmall {
            image {
              data {
                attributes {
                  url
                  alternativeText
                  formats
                }
              }
            }
            title
            name
            organisation
          }
          ... on ComponentContentSingleImage {
            singleImage {
              data {
                attributes {
                  url
                  alternativeText
                  formats
                }
              }
            }
            fullWidth
          }
          ... on ComponentContentImageCarousel {
            images {
              data {
                attributes {
                  url
                  alternativeText
                  formats
                }
              }
            }
          }
          ... on ComponentContentTwoColumnsText {
            text1
            text2
          }
          ... on ComponentContentTwoColumnsFacts {
            twoColumnsFactsTitle: Title
            blocks {
              Number
              Description
            }
          }
          ... on ComponentContentThreeColumnsFacts {
            threeColumnsFactsTitle: Title
            blocks {
              Number
              Description
            }
          }
          ... on ComponentContentFourCards {
            fourCardsTitle: title
            blocks {
              image {
                data {
                  attributes {
                    url
                    alternativeText
                    formats
                  }
                }
              }
              title
              description
            }
          }
          ... on ComponentContentTrustedBy {
            blocks {
              name
              logo {
                data {
                  attributes {
                    url
                    alternativeText
                    formats
                  }
                }
              }
              url
            }
          }
          ... on ComponentContentThreeColumnCards {
            threeColumnCardsTitle: title
            blocks {
              title
              description
            }
          }
        }
        HireUs {
          Title
          Description
          Caption
        }
        seo {
          metaTitle
          metaDescription
          metaImage {
            data {
              attributes {
                url
                alternativeText
                formats
              }
            }
          }
          metaSocial {
            socialNetwork
            title
            description
            image {
              data {
                attributes {
                  url
                  alternativeText
                  formats
                }
              }
            }
          }
        }
      }
    }
  }
}
`;
